<nz-table #productTable [nzData]="products" [nzLoading]="productService.loading$ | async" [nzNoResult]="noData">
	<thead>
		<tr>
			<th>Name</th>
			<th>Engine</th>
			<th></th>
		</tr>
	</thead>
	<tbody>
		@for (product of products; track $index) {
			<tr [class.selected]="product.name === productService.selectedProductBs$.value?.name">
				<td>{{ product.name }}</td>
				<td>{{ product.engine_name }}</td>
				<td>
					@if (mode === 'edit') {
						@if (product.name === productService.selectedProductBs$.value?.name) {
							<button nz-button (click)="selectProduct(undefined)">Clear</button>
						}
						@if (product.name !== productService.selectedProductBs$.value?.name) {
							<span>&nbsp;</span>
							<button nz-button nzType="primary" (click)="selectProduct(product)">Edit</button>
						}
						<span>&nbsp;</span>
						<button
							nz-button
							nzDanger
							nz-popconfirm
							nzPopconfirmTitle="Are you sure delete this?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="deleteProduct(product.name)"
						>
							Delete
						</button>
					}
					@if (mode === 'select') {
						<span>&nbsp;</span>
						<button nz-button nzType="primary" (click)="selectProduct(product)">Select</button>
					}
				</td>
			</tr>
		}
	</tbody>
	<ng-template #noData>
		<nz-typography>No products available</nz-typography>
	</ng-template>
</nz-table>
